import { AdminAppState, PlaceEntry } from '../../state';
import { getPlace } from './get-place';

export const getPlaceLocation = (placeKey: string) => (
  store: AdminAppState,
): PlaceEntry['place']['locations'][0] => {
  const { locations } = getPlace(placeKey)(store);
  if (locations.length > 0) {
    return locations[0];
  } else {
    return {};
  }
};
